import { Button, ButtonGroup } from '@mui/material';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

interface DesignRoutesProps {
    selectedRoute: string;
}

export const DesignRoutes = ({ selectedRoute }: DesignRoutesProps) => {
    const navigate = useNavigate();

    return (
        <ButtonGroup>
            <Button
                variant={'text'}
                color={'secondary'}
                style={{
                    textTransform: 'capitalize',
                    color: selectedRoute === 'models' ? '#1976D2' : 'white',
                }}
                onClick={() => navigate('/models')}
            >
                Models
            </Button>

            <Button
                variant={'text'}
                color={'secondary'}
                style={{
                    textTransform: 'capitalize',
                    color:
                        selectedRoute === 'manufacturers' ? '#1976D2' : 'white',
                }}
                onClick={() => navigate('/manufacturers')}
            >
                Manufacturers
            </Button>

            <Button
                variant={'text'}
                style={{
                    textTransform: 'capitalize',
                    color: selectedRoute === 'coverages' ? '#1976D2' : 'white',
                }}
                onClick={() => navigate('/coverages')}
            >
                Coverages
            </Button>
        </ButtonGroup>
    );
};

DesignRoutes.propTypes = {
    selectedRoute: PropTypes.string,
};
